// ** React Imports
import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'
import axios from 'axios'
import Switch from '@mui/material/Switch';
import { AddCompetency } from "../Competency/Modal/AddCompetency"
import { IconButton, Tooltip } from '@mui/material';
import { Add, Delete, Edit } from '@mui/icons-material';
import EditQuestion from "../Competency/Modal/EditQuestion"

const Question = ({questions, surveyId, competencyId, getList, ...rest}) => {
  const authUser = localStorage.getItem('FF-authUser');
  const authUserId = JSON.parse(authUser).id;
  
  const [showQuestion, setShowQuestion] = useState(false);
  const [editQuestionId, setEditQuestionId] = useState(0);

  const location = useLocation();
  const current_path = location.pathname;

  const handleQuestionEdit = (id) => {
      setEditQuestionId(id);
      setShowQuestion(true);
  }
  const handleQuestionClose = () => setShowQuestion(false);
   
  const handleQuestionStatus = (e, questionId) => {
    var status = e.target.checked === true ? '1' : '0';
    axios.put(`api/questions/updateStatus?id=${questionId}`, {status}).then(res => {                
    })
    .catch(err => {
    })
  }

  const handleSurveyQuestionStatus = (e, surveyId, competencyId, questionId) => {
    var url = `api/questions/updateSurveyQuestionStatus?id=${questionId}&surveyId=${surveyId}&competencyId=${competencyId}`
    var status = e.target.checked === true ? '1' : '0';
    axios.put(url, {status}).then(res => {                
    })
    .catch(err => {
    })
  }

  const handleQuestionDelete = (questionId) => {
    Swal.fire({
      title: 'Are you sure you want to delete?',
      showCancelButton: true,
      confirmButtonColor: '#45a7c4',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) { 
          axios.delete(`/api/questions/delete?id=${questionId}`).then((res) =>{
              if(res.data.success){                             
                Swal.fire('Deleted!', '', 'success').then(result => { 
                  getList();
                })
              } 
              else{
                Swal.fire(res.data.message, '', 'info')
              }
          }).catch((error) => {
              console.log(error);                     
              Swal.fire(error.message, '', 'info')           
          });
      } else if (result.isDenied) {
        Swal.fire('Cancelled!', '', 'info')
      }
    }) 
  }

  return (
    <>
    {questions && questions.length > 0 ?
      questions.map((question) => (
          <tr key={"questions-tr_"+question.id}>
              <td>
                {/* <i className="fab fa-angular fa-lg text-danger me-3"></i> */}
              <strong>
              {question.question_type && question.question_type.name ? question.question_type.name : question.question.question_type.name}
              </strong></td>
              <td>{question.name ? question.name : question.question.name}</td>
              <td>
              {current_path === '/survey_templates' && authUserId === question.userId  ? 
                  <Switch className="Rj-toggle" color="info" onChange={(e) => handleQuestionStatus(e, question.id)} defaultChecked={question.status === '1' ? true : false}/>  : ""
              }
              {current_path === '/survey_templates' ? 
                  <Switch className="Rj-toggle" color="info" onChange={(e) => handleSurveyQuestionStatus(e, surveyId, competencyId, question.question.id)} defaultChecked={question.status === '1' ? true : false}/> :""
              }
              {current_path === '/competencies'  ? 
                  <Switch className="Rj-toggle" color="info" onChange={(e) => handleQuestionStatus(e, question.id)} defaultChecked={question.status === '1' ? true : false}/> : ""
              }
              </td>
              <td>
              {current_path === '/competencies' || current_path === '/competency_libraries' ? 
                  <>
                  <div className="d-flex align-items-center">
                  <Tooltip onClick={() => handleQuestionEdit(question.id)} title="Edit Question" size='small' className='icon icon-sm icon-secondary me-3'>
                      <IconButton>
                          <Edit />
                      </IconButton>
                  </Tooltip>
                  <Tooltip onClick={() => handleQuestionDelete(question.id)} title="Delete Question" size='small' className='icon icon-sm icon-primary me-3'>
                      <IconButton>
                          <Delete />
                      </IconButton>
                  </Tooltip>
                  </div>
                </> : ""
              }
              </td>
          </tr>
      ))
    : 
    <tr key={"questions-tr0"}><td>No Question Available!</td>
    </tr> }
    
    <EditQuestion showQuestion={showQuestion} setShowQuestion={setShowQuestion} handleQuestionClose={handleQuestionClose} getList={getList} editQuestionId={editQuestionId} setEditQuestionId={setEditQuestionId} />   
    </>
    
  )
}
export default Question